export default __webpack_public_path__ + "static/media/Analysts.b5ce5890.png";